"use client";

import React from "react";

/**
 * Talent card skeleton that mirrors the real card's layout at all breakpoints:
 * - Same aspect ratio (3/4)
 * - Same border/shadow and rounded corners
 * - Bottom overlay with gradient and two lines (title + meta) sized responsively
 */
export default function TalentCardSkeleton({
  variant = 'default',
  className
}: {
  variant?: 'default' | 'legacy';
  className?: string;
}) {
  return (
    <div className={`group block animate-pulse ${className || ''}`}>
      <div className="relative overflow-hidden rounded-2xl border border-zinc-200/60 dark:border-zinc-800 shadow-sm p-0">
        <div className="relative w-full aspect-[3/4]">
          {/* Image area */}
          <div className="absolute inset-0 skeleton" aria-hidden />

          {/* Gradient overlay (matches real card) */}
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 via-black/40 to-transparent" aria-hidden />

          {/* Text overlay area — title + meta */}
          <div className="absolute inset-x-0 bottom-0 px-4 pb-4 pt-2 md:px-5 md:pb-5">
            <div className="max-w-[95%] space-y-1.5">
              <div className="rounded skeleton h-5 w-3/4" />
              <div className="rounded skeleton h-3 w-1/3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
